export default __webpack_public_path__ + "static/media/2.61cdb2ae.jpg";